export const SIEMPRE_MAS_MUSICA_LOGO_SRC =
  'https://files.tnonetwork.com/shows/logo/siempremasmusica.png';
export const SIEMPRE_MAS_MUSICA_COVER_SRC =
  'https://files.tnonetwork.com/shows/cover/siempremasmusica.jpg';
export const ARLENE_FLORES_ANCHOR_SRC =
  'https://files.tnonetwork.com/users/profile/arleflores.jpg';
